var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopUpLiner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7 9.00034H9.00003M9.00003 9.00034H6.30003M9.00003 9.00034V11.7003M9.00003 9.00034L9.00003 6.30034M16.2 9.00078C16.2 12.9772 12.9765 16.2008 9.00003 16.2008C5.02358 16.2008 1.80003 12.9772 1.80003 9.00078C1.80003 5.02433 5.02358 1.80078 9.00003 1.80078C12.9765 1.80078 16.2 5.02433 16.2 9.00078Z",
    stroke: "#F9009E",
    strokeWidth: 1.41667,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopUpLiner);
export default __webpack_public_path__ + "static/media/TopUpLiner.5feb7479304eac9bba3848e2bb25ba6a.svg";
export { ForwardRef as ReactComponent };